import { render, staticRenderFns } from "./DialogLayout.vue?vue&type=template&id=627e5791&scoped=true&"
import script from "./DialogLayout.vue?vue&type=script&lang=js&"
export * from "./DialogLayout.vue?vue&type=script&lang=js&"
import style0 from "./DialogLayout.vue?vue&type=style&index=0&id=627e5791&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627e5791",
  null
  
)

export default component.exports